var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full flex justify-center items-center my-4"},[_c('Spinner',{attrs:{"color":"rgba(107, 114, 128, var(--tw-bg-opacity))"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }